module.exports = __webpack_public_path__ + "media/images/img10-a879ec7e8307a801964380050a910668.png";